import { useTranslation } from 'react-i18next';

import { Button } from '@/common/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/common/components/ui/dialog';

interface StartPolicyErrorDialogProps {
  open: boolean;
  onClose: () => void;
}

export const StartPolicyErrorDialog = ({
  open,
  onClose,
}: StartPolicyErrorDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="w-[425px] min-h-[168px] p-6 gap-3"
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="gap-y-2">
          <DialogTitle>{t('policy.startPolicyErrorTitle')}</DialogTitle>
          <DialogDescription>
            {t('policy.startPolicyErrorDescription')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="justify-start sm:justify-start pt-2">
          <Button variant="secondary" onClick={onClose}>
            {t('policy.refreshNow')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
